<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">

        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2 > Booking & Ticketing </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='55'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12  mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="56">
                    <h4 >Booking and Ticketing</h4>
                    <label for="" class="mt-4" >A booking and ticketing feature is a
                        helpful tool for
                        merchants. It lets people reserve spots or buy tickets for things like
                        services, events, or activities. This makes it easier to plan and make sure
                        you can use or attend to what you want. Merchants use these features to make
                        it simple for customers to book their services or buy tickets. It helps
                        businesses run smoothly, make customers happy, and earn more money.
                        Businesses can also use the PayG app to keep track of all the bookings they
                        get, so they can manage them well.</label>

                    <label for="" class="mt-4" >In India every other person is
                        standing in a queue
                        for booking the tickets, booking an appointment, booking an event, etc. It
                        is difficult for both the customers and the merchants to manage and book
                        tickets. So, at PayG, we launched a new product called “Booking and
                        Ticketing” which is available for free at PayG. </label>
                                    </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="57">
                    <h4 >What is Booking and Ticketing?</h4>
                    <label for="" class="mt-4" >Booking and ticketing features for
                        merchants refer to
                        functionalities and tools that enable businesses to manage reservations,
                        appointments, and ticket sales for their services, events, activities, or
                        offerings. These features empower merchants to efficiently organize their
                        operations, enhance customer experiences, and optimize revenue streams.
                        Merchants can also access a robust booking management system, enabling them
                        to track and handle their bookings efficiently. </label>
                    
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="58">

                    <h4 >Benefits of Booking and Ticketing</h4>
                    <label for="" class="mt-3" >
                        Here's an overview of how booking and ticketing features benefit merchants:
                    </label>
                    
                    <ul class="mt-3" >
                        <li>Creating a booking profile on PayG is very easy.</li>
                        <li class="mt-3">Merchants can use different “Ready to use templates”.</li>
                        <li class="mt-3">Merchants can generate their own booking URLs and QR codes
                            and share them with their customers to receive payments.</li>
                        <li class="mt-3">The customers can book their tickets from anywhere and
                            through any device, for example, laptop, mobile phone, etc</li>
                        <li class="mt-3">Merchants can track revenue generated from events, and
                            manage bookings made by their customers</li>
                        <li class="mt-3">PayG provides an integrated payment gateway to take online
                            payments smoothly.</li>
                    </ul>
               
                    <label for="" class="mt-3" >
                        In PayG mobile application the personal side can be used by the user to book
                        tickets and merchant side can be used to scan the tickets for check in.
                    </label>
                  
                </div>

            </div>
        </div>
  </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
                   
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#55">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   What is Booking and Ticketing? </span>
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#56">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >

                                    Introduction to Booking and Ticketing</span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#57">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    > What is Booking and Ticketing?

                                </span>
                           
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#58">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    Benefits of Booking and Ticketing
                                </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Booking and Ticketing new.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    Booking and Ticketing Overview </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Booking and Ticketing new.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
             
                <a [routerLink]="['/easy-collect']">   <button class="btn btn-color" (click)="menues('smart collect')" >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Smart Collect
                </button></a>
              
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/create-profile']"><button class="btn btn-color" (click)="menues('Creating Profile')"
                    >Creating
                    Profile
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a> 
               </div>
        </div>
    </div>
    </div>